export default "__VITE_ASSET__BEh1501s__"